











































import Vue from 'vue';
import Component from 'vue-class-component';
import {Watch} from 'vue-property-decorator';
import {required, minLength} from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';
// @ts-ignore
import { api } from '../../../proxy.config';

import UserProfileIcon from '@/assets/icon/user-profile.svg';

const { mapFields } = createHelpers({
  getterType: 'getLoginFormField',
  mutationType: 'updateLoginFormField',
});

const validations = {
  login: {
    required
  },
  password: {
    required,
    minLength: minLength(8)
  }
};

@Component({
  validations,
  computed: {...mapFields([
      'login',
      'password',
      'submitSuccess'
    ])
  }
})
export default class LoginForm extends Vue {
  private submitSuccess!: boolean;
  public UserProfileIcon = UserProfileIcon;

  public loginErrorMessageList = {
    required: 'Anmelden ist erforderlich'
  };
  public passwordErrorMessageList = {
    required: 'Passwort wird benötigt',
    minLength: 'Das Passwort muss aus mindestens 8 Zeichen bestehen'
  };

  public openModal(modal: string) {
    this.$emit('openModal', modal);
  }

  public submit(): void {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.$store.dispatch('login');
    }
  }

  public goToDBPAuth() {
    // Redirect to DPB login (QS server origin is used for development)
    // After redirect back to QS you can use authorizationToken cookie to access DPB user on development server
    const origin = process.env.NODE_ENV === 'development' ? api['qs'] : '/';
    window.location.href = `${origin}oauth2/authorization/keycloak`;
  }

  @Watch('submitSuccess')
  public onSubmitSuccess(success: boolean) {
    if (success) this.$emit('closeModal');
  } 
}
